export default __webpack_public_path__ + "static/media/queen_black.cf388bf4.svg";